export default __webpack_public_path__ + "static/media/red-up.3655b32b.svg";